<div class="text-center">
    <p class="day-number" #test>{{slot.Day()}}</p>

    <div *ngFor="let daySlot of slot.DaySlots()" class="day-slot">
        <leasing-day-slot *ngIf="daySlot.Available()"
                          [daySlot]="daySlot"
                          [id]="buildId(daySlot)"
                          (selected)="onDaySlotSelected()">
        </leasing-day-slot>
        <p *ngIf="!daySlot.Available()" class="day-slot-text taken">{{calendarTimeAsString(daySlot)}}</p>
    </div>

</div>



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/userReservation/calendar/slot/slot.html